export const errCodeToMsg = {
  4921009: '请检查上级IP地址或端口是否正确',
  4921001: '请检查上级接入码是否已失效',
  4907002: '可分配余额不足',
  4907003: '可分配台数不足',
  4801003: 'IP规则冲突'
}
